import { ServiceCounter } from "@/model/data/componentsMaintenance/ServiceCounter";
import { AxiosResponse } from "axios";
import { ApiGenericResponse } from "../ApiGenericResponse";
import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";

const ENDPOINT = "/maintenance/service_counters";

export class GetServiceCountersCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";

    params: GetServiceCountersReqData = null;

    constructor(params: GetServiceCountersReqData = null) {
        super();
        this.params = params;
    }

    public async execute(): Promise<GetServiceCountersResData> {
        let res = await this.executeCommand(null, null, this.params);
        return new GetServiceCountersResData(res);
    }
}

export class GetServiceCountersReqData {
    installationName: string;
    machineSerialNumber: string;

    constructor(installationName: string, machineSerialNumber: string) {
        this.installationName = installationName;
        this.machineSerialNumber = machineSerialNumber;
    }
}

export class GetServiceCountersResData extends ApiGenericResponse {
    serviceCounters: ServiceCounter[];

    constructor(response: AxiosResponse) {
        super(response);
        this.serviceCounters = [];
        if (response.data && response.data.Payload.ServiceCounters && response.data.Payload.ServiceCounters.length > 0) {
            response.data.Payload.ServiceCounters.forEach((e) => {
                let m = new ServiceCounter();
                m.parse(e);
                this.serviceCounters.push(m);
            });
        }
    }
}
